import '../social_content_header_view.js.coffee'
Namespace 'Monitoring.Views.SocialContents.LinkedIn'

class Monitoring.Views.SocialContents.LinkedIn.LinkedInContentHeaderView extends
      Monitoring.Views.SocialContents.SocialContentHeaderView

  initialize: (el, model) ->
    @model = model
    @$el = el

  normalizeSubType: ->
    I18n.t("monitoring.metrics.linkedin.#{@model.subType()}")

  _genericAvatarView: ->
    new Monitoring.Views.LinkedIn.LinkedInAvatarView(@model)
